import { render, staticRenderFns } from "./GraphicsLogoTwoSection.vue?vue&type=template&id=4decf8c9"
import script from "./GraphicsLogoTwoSection.vue?vue&type=script&lang=ts"
export * from "./GraphicsLogoTwoSection.vue?vue&type=script&lang=ts"
import style0 from "./GraphicsLogoTwoSection.vue?vue&type=style&index=0&id=4decf8c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports